// extracted by mini-css-extract-plugin
module.exports = {"popper":"s_popper__3L24l","title":"s_title__2pxqh","closeButton":"s_closeButton__3ZC_c","checkbox":"s_checkbox__2Nqrz"};